/* src/app/components/default-address-warning/default-address-warning.component.scss */
.header,
.header > div {
  gap: 15px;
}
.header ion-icon {
  width: 30px;
  height: 30px;
}
.header h1 {
  color: black;
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
}
ion-button {
  margin: 0;
  min-height: 0;
}
ion-button > ion-icon {
  width: 24px !important;
  height: 24px !important;
  color: black;
}
ion-button.close {
  --border-radius: 0px;
}
ion-button.close::part(native) {
  padding: 0;
}
h2 {
  font-family: "Barlow Semi Condensed";
  font-size: 22px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.address-info {
  padding: 15px;
  font-size: 20px;
  font-weight: 500;
  line-height: normal;
  color: #949494;
  border-radius: 15px;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);
}
.message {
  color: #949494;
  font-family: "Barlow Semi Condensed";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.buttons > button {
  font-size: 18px;
  font-weight: 500;
  line-height: normal;
  border-radius: 15px;
  padding: 14px 18px;
  outline: none;
}
/*# sourceMappingURL=default-address-warning.component-RBMCDAD4.css.map */
